module.exports = __webpack_public_path__ + "img/mu.eb5cbe52.svg";